var _g, _polygon, _polygon2, _polygon3, _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 280",
    width: 300,
    height: 280,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 85)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -45,
    x2: 0,
    y2: -65,
    stroke: "#F7941D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: -39,
    x2: 32,
    y2: -56,
    stroke: "#F7941D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: -22,
    x2: 56,
    y2: -32,
    stroke: "#F7941D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 0,
    x2: 65,
    y2: 0,
    stroke: "#F7941D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -22,
    y1: -39,
    x2: -32,
    y2: -56,
    stroke: "#F7941D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39,
    y1: -22,
    x2: -56,
    y2: -32,
    stroke: "#F7941D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -45,
    y1: 0,
    x2: -65,
    y2: 0,
    stroke: "#F7941D",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,-30 8,-10 30,-10 13,4 20,25 0,13 -20,25 -13,4 -30,-10 -8,-10",
    fill: "#F7941D"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "70,190 150,95 230,190",
    fill: "#4A7C2E"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "30,190 120,110 210,190",
    fill: "#2E5A1E"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "110,190 180,115 250,190",
    fill: "#6AAF35"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 188,
    width: 250,
    height: 8,
    rx: 3,
    fill: "#4A7C2E"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 228,
    textAnchor: "middle",
    fontFamily: "Arial Black, Arial, sans-serif",
    fontWeight: 900,
    fontSize: 28,
    letterSpacing: 4,
    fill: "#1A1A1A"
  }, "ADVENTURE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 258,
    textAnchor: "middle",
    fontFamily: "Arial Black, Arial, sans-serif",
    fontWeight: 900,
    fontSize: 28,
    letterSpacing: 4,
    fill: "#1A1A1A"
  }, "WORKS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d3f9c485cab9b37ef40bd344a89925d0.svg";
export { ForwardRef as ReactComponent };